import React from "react";
import "../styles/Contact.css";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiSend
} from "react-icons/fi";

const Contact = () => {
  return (
    <div>
      <section className="contact-wrapper">
        {/* Header */}
        <div className="contact-header">
          <h2>Get in Touch</h2>
          <p>தொடர்பு கொள்ள</p>
        </div>

        {/* Info Cards */}
        <div className="contact-cards">
          <div className="contact-card">
            <span className="icon-circle12">
              <FiMapPin />
            </span>
            <h4>Visit Us</h4>
            <p>எங்களைச் சந்திக்கவும்</p>
            <span className="card-text">
             Pin -637502
            </span>
          </div>

          <div className="contact-card">
            <span className="icon-circle12">
              <FiPhone />
            </span>
            <h4>Call Us</h4>
            <p>எங்களை அழைக்கவும்</p>
            <span className="card-text">9176995369
            </span>
            <span className="card-text">
              9894081162</span>
          </div>

          <div className="contact-card">
            <span className="icon-circle12">
              <FiMail />
            </span>
            <h4>Email Us</h4>
            <p>மின்னஞ்சல் செய்யவும்</p>
            <span className="card-text">bjpsudharadhakrishnan <br /> 2025@gmail.com.</span>
          </div>
        </div>

        {/* Social Icons */}
        <div className="social-icons">
          <span><FiFacebook /></span>
          <span><FiTwitter /></span>
          <span><FiInstagram /></span>
          <span><FiYoutube /></span>
        </div>

        {/* Message Form */}
        <div className="message-section">
          <div className="message-card">
            <h3>Send us a Message</h3>
            <p>எங்களை அணுகவும்</p>

            <div className="form-group">
              <label>Name / பெயர்</label>
              <input type="text" placeholder="Your Full Name" />
            </div>

            <div className="form-group">
              <label>Mobile Number / கைபேசி எண்</label>
              <input type="text" placeholder="10-digit Mobile Number" />
            </div>

            <div className="form-group">
              <label>Message / செய்தி</label>
              <textarea placeholder="How can we help you?" />
            </div>

            <button className="submit-btn">
              Submit Message <FiSend />
            </button>
          </div>
        </div>
      </section>
      <section className="join-wrapper">
        {/* Map Placeholder */}
        <div className="map-container">
          <FiMapPin className="map-icon" />
          <h4>Google Map Placeholder</h4>
          <p>New Delhi Headquarters</p>
        </div>

        {/* CTA Section */}
        <div className="cta-container">
          <h2>Join AIADMK for a better Tamil Nadu</h2>
          <p>
            சிறப்பான தமிழகத்திற்கு அதிமுகவில் இணையுங்கள்
          </p>
          {/* <button className="cta-btn">Become a Member Today</button> */}
        </div>
      </section>
    </div>
  )
}

export default Contact